module.exports = __webpack_public_path__ + "static/media/class_job_033.9e7eac42.svg";